import { render, staticRenderFns } from "./UserControlPanelTabs.vue?vue&type=template&id=0a0560f8&"
import script from "./UserControlPanelTabs.vue?vue&type=script&lang=ts&"
export * from "./UserControlPanelTabs.vue?vue&type=script&lang=ts&"
import style0 from "./UserControlPanelTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports